<template>
  <div class="version-measure">
    <span class="measure-name">{{
      $t(`portfolioManager.portfolioLifecycle.${translateKey}`)
    }}</span>
    <span class="measure-value">{{
      `${valueFormatter(value)} ${suffixes[translateKey] || ""}`
    }}</span>
  </div>
</template>

<script>
export default {
  name: "version-measure",
  props: {
    value: Number || String,
    translateKey: String,
  },
  data() {
    return {
      suffixes: {
        expected_return: "% p.a.",
        volatility: "% p.a.",
        sharpe: "%",
        valueAtRisk_5: "",
      },
    };
  },
  methods: {
    valueFormatter(val) {
      return (val * 100).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.version-measure {
  display: flex;
  margin-bottom: 1rem;
  align-items: baseline;
  justify-content: space-between;
  .measure-name {
    text-transform: uppercase;
    color: #002333;
    font-weight: 500;
    width: toRem(90);
    display: block;
  }
  .measure-value {
    font-size: $s-font;
    font-weight: 500;
  }
}
</style>